<template>
  <div class="myReceiveResumeIndex">
    <div class="cont">
      <div class="selectCont">
        <el-button style="margin: 0px auto 30px auto;width: 260px;" type="primary" @click="goupload()">+上传简历</el-button>
        <div v-bind:class="item.id === setId ? 'resitem resitemactive' : 'resitem'" v-for="item in jlLIst" :key="item.id"
          @click="getResInfo(item.id)">
          <div class="p1">{{ item.name }}</div>
          <div class="p2">{{ item.nowJob }}</div>
          <div class="p3">{{ item.sex }}{{ ' ' }}{{ item.education }}{{ ' ' }}{{ item.workingLifeMax }}年</div>
        </div>
        <el-pagination style="margin: 30px auto 0 auto; text-align: center;" @current-change="getResList()"
          :current-page.sync="pageNumber" :page-size.sync="pageSize" layout="total, prev, next, jumper"
          :total="pagetotal">
        </el-pagination>
      </div>
      <div class="tableCont" v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
        <div v-if="setId">
          <div class="bt">简历详情
            <div class="actionbox" v-if="resinfo">
              <el-button type="danger" @click="goyh()">前往AI优化简历</el-button>
              <el-button type="primary" @click="goltbg()"> <i class="el-icon-download"></i> AI优化简历下载</el-button>
            </div>
          </div>
          <el-button type="primary" class="pppdgdg" icon="el-icon-download" circle></el-button>
          <div v-if="!resinfo">
            请重新上传此简历
          </div>
          <div v-if="resinfo">
            <el-descriptions title="候选人基本信息" style="margin-top: 50px">
              <el-descriptions-item label="姓名">{{resinfo['basic_info'].name}}</el-descriptions-item>
              <el-descriptions-item label="年龄">{{resinfo['basic_info'].age}}</el-descriptions-item>
              <el-descriptions-item label="性别">{{resinfo['basic_info'].gender}}</el-descriptions-item>
              <el-descriptions-item label="学历">{{resinfo['basic_info'].degree}}</el-descriptions-item>
              <el-descriptions-item label="生日">{{resinfo['basic_info'].date_of_birth}}</el-descriptions-item>
              <el-descriptions-item label="公司">{{resinfo['basic_info'].current_company}}</el-descriptions-item>
              <el-descriptions-item label="职位">{{resinfo['basic_info'].current_position}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="联系方式" style="margin-top: 20px">
              <el-descriptions-item label="QQ">{{resinfo['contact_info'].QQ}}</el-descriptions-item>
              <el-descriptions-item label="EMAIL">{{resinfo['contact_info'].email}}</el-descriptions-item>
              <el-descriptions-item label="手机号码">{{resinfo['contact_info'].phone_number}}</el-descriptions-item>
              <el-descriptions-item label="微信号">{{resinfo['contact_info'].wechat}}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="教育经历" style="margin-top: 20px" :column="1">
              <el-descriptions-item v-for="(item,key) in resinfo['education_experience']" :key="'edu'+key" :label="item.school_name">{{ item.degree + '  ' }}{{ item.major  + '  ' }}{{ item.start_time_year + '.' +  item.start_time_month + '~' + item.end_time_year + '.' +  item.end_time_month}}</el-descriptions-item>
            </el-descriptions>
            <div class="bt" id="boxxxx1">工作经验</div>
            <div v-if="resinfo['work_experience'].length <= 0">
              候选人尚未填写工作经验
            </div>
            <el-descriptions v-for="(item,index) in resinfo['work_experience']" :key="'work'+index"  :title="item.job_title" style="margin-top: 50px" :column="1" >
              <template slot="extra">
                <el-button @click="getYhRes(index, item.description)" type="primary" size="small">AI简历优化</el-button>
              </template>
              <el-descriptions-item label="公司名称">{{item.company_name}}</el-descriptions-item>
              <el-descriptions-item label="工作部门">{{item.department}}</el-descriptions-item>
              <el-descriptions-item label="入职时间">{{item.start_time_year + '.' + item.start_time_month}}</el-descriptions-item>
              <el-descriptions-item label="离职时间" v-if="item.end_time_year !== ''">{{item.end_time_year + '.' + item.end_time_month}}</el-descriptions-item>
              <el-descriptions-item label="工作介绍" contentClassName="wpline">{{item.description}}</el-descriptions-item>
            </el-descriptions>
            <div class="bt">项目经验</div>
            <div v-if="resinfo['project_experience'].length <= 0">
              候选人尚未填写项目经验
            </div>
            <el-descriptions v-for="(item,index) in resinfo['project_experience']" :key="'pro'+index"  :title="item.project_name" style="margin-top: 50px" :column="1" >
              <template slot="extra">
                <el-button @click="getYhRes1(index, item.description)" type="primary" size="small">AI简历优化</el-button>
              </template>
              <el-descriptions-item label="项目中的职位">{{item.job_title}}</el-descriptions-item>
              <el-descriptions-item label="项目开始时间">{{item.start_time_year + '.' + item.start_time_month}}</el-descriptions-item>
              <el-descriptions-item label="项目结束时间" v-if="item.end_time_year !== ''">{{item.end_time_year + '.' + item.end_time_month}}</el-descriptions-item>
              <el-descriptions-item label="工作介绍"   contentClassName="wpline">{{item.description}}</el-descriptions-item>
            </el-descriptions>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="优化结果"
      :visible.sync="dialogVisible"
      width="60%"
      :before-close="handleClose">
      <span>确认是否使用如下AI简历优化内容（可进行编辑）</span>
      <div class="boxxx">
        <p v-if="uhtype !== '' && uhindex !== ''"  class="boxxx11">
          {{ '原始内容：\n' }}
          {{ resinfo[uhtype][uhindex].description }}
        </p>
        <el-input
          type="textarea"
          :rows="15"
          placeholder="请输入内容"
          v-model="uhres">
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="upResInfo">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import Config from '../config/index'
import { Message } from 'element-ui'
import Docxtemplater from "docxtemplater";
import PizZip from "pizzip";
import PizZipUtils from "pizzip/utils/index.js";
import { saveAs } from "file-saver";


function loadFile(url, callback) {
  PizZipUtils.getBinaryContent(url, callback);
}




export default {
  name: 'myReceiveResume',
  props: {},
  data() {
    return {
      jlLIst: [],
      pageSize: 8,
      pageNumber: 1,
      pagetotal: 0,
      resinfo: false,
      loading: false,
      setId: false,
      uhtype: '',
      uhindex: '',
      uhres: '',
      dialogVisible: false
    }
  },
  watch: {},
  created: function () { },
  methods: {
    goyh: function () {
      let d = document.getElementById('boxxxx1')
      

      document.body.scrollTop = document.documentElement.scrollTop = d.offsetTop
    },
    goltbg: function () {
      let that = this
      this.loading = true
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
      var urlencoded = new URLSearchParams()
      urlencoded.append('pkkresid', that.setId)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getlinkpkk', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          let res = JSON.parse(result).msg
          if (res === undefined) {
            that.$message.error('请重新上传此简历')
            return false
          }
          that.resinfo = res
          that.getResTag()
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getYhRes: function (index, text) {
            this.$message({
                showClose: true,
                message: 'AI优化中',
                duration: 0
            });
            let that = this

            var myHeaders = new Headers()
            myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

            var urlencoded = new URLSearchParams()
            urlencoded.append('text', text)
            urlencoded.append('user', localStorage.getItem('token'))

            var requestOptions = {
                method: 'POST',
                headers: myHeaders,
                body: urlencoded,
                redirect: 'follow',
            }

            that.loading = true

            fetch(' https://api.qilinpin.cn/gptapi/api/getYhRes', requestOptions)
                .then((response) => response.text())
                .then((result) => {
                    Message.closeAll()
                    that.loading = false
                    let res = JSON.parse(result).msg
                    that.uhtype = 'work_experience'
                    that.uhindex = index
                    that.uhres = res
                    that.dialogVisible = true
                    // that.resinfo.work_experience[index].description = res
                })
                .catch((error) => {
                    Message.closeAll()
                    that.loading = false
                    that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                    console.log('error', error)
                })
        },
      getYhRes1: function (index, text) {
          this.$message({
              showClose: true,
              message: 'AI优化中',
                duration: 0
          });
          let that = this

          var myHeaders = new Headers()
          myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

          var urlencoded = new URLSearchParams()
          urlencoded.append('text', text)
          urlencoded.append('user', localStorage.getItem('token'))

          var requestOptions = {
              method: 'POST',
              headers: myHeaders,
              body: urlencoded,
              redirect: 'follow',
          }

          that.loading = true

          fetch(' https://api.qilinpin.cn/gptapi/api/getYhRes', requestOptions)
              .then((response) => response.text())
              .then((result) => {
                  Message.closeAll()
                  that.loading = false
                  let res = JSON.parse(result).msg
                  that.uhtype = 'project_experience'
                  that.uhindex = index
                  that.uhres = res
                  that.dialogVisible = true
                  // that.resinfo.project_experience[index].description = res
              })
              .catch((error) => {
                  Message.closeAll()
                  that.loading = false
                  that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
                  console.log('error', error)
              })
      },
    deleteRes: function (item) {
      let that = this
      that.loading = true
      this.$confirm('确认删除该简历？')
        .then(_ => {
          let data = {
            id: that.setId
          }
          axios({
            method: 'POST',
            url: Config.path + '/api/candidate/delResume',
            headers: {
              token: localStorage.getItem('token'),
              'content-type': 'application/json',
            },
            data: data,
          })
            .then((res) => {
              that.loading = false
              if (res.data.success === '1') {
                that.pageNumber = 1
                that.pagetotal = 0
                that.resinfo = false
                that.setId = false
                that.getResList()
              } else {
                that.$message.error(res.data.message)
              }
            })
            .catch((err) => {
              that.loading = false
              that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
            })
        })
        .catch(_ => { });
    },
    goupload: function () {
      this.$router.push({
        name: 'upload',
      })
    },
    getResList: function () {
      let that = this
      that.loading = true
      let data = {
        pageSize: that.pageSize,
        pageNum: that.pageNumber
      }
      axios({
        method: 'POST',
        url: Config.path + '/api/candidate/myResumeList',
        headers: {
          token: localStorage.getItem('token'),
          'content-type': 'application/json',
        },
        data: data,
      })
        .then((res) => {
          that.loading = false
          if (res.data.success === '1') {
            let demoList = []
            demoList = res.data.content.list
            that.pagetotal = res.data.content.total
            that.jlLIst = demoList
            if (demoList.length > 0) {
              that.getResInfo(demoList[0].id)
            }
          } else {
            that.$message.error(res.data.message)
          }
        })
        .catch((err) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
        })
    },
    getResInfo: function (id) {
      let that = this
      that.resinfo = false
      that.setId = false
      that.setId = id
      this.loading = true
      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
      var urlencoded = new URLSearchParams()
      urlencoded.append('pkkresid', id)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getlinkpkk', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          let res = JSON.parse(result).msg
          if (res === undefined) {
            that.$message.error('请重新上传此简历')
            return false
          }
          that.resinfo = res
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    upResInfo: function () {
      let that = this
      this.loading = true
      let newResInfo = that.resinfo
      newResInfo[that.uhtype][that.uhindex].description = that.uhres

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')
      var urlencoded = new URLSearchParams()

      urlencoded.append('pkkresid', newResInfo['pkkresid'])
      urlencoded.append('type',  that.uhtype)
      urlencoded.append('index',  that.uhindex)
      urlencoded.append('des',  that.uhres)



      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/upResInfo', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.dialogVisible = false
          that.loading = false
          let res = JSON.parse(result).msg
          that.getResInfo(res.pkkresid)
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getResTag: function () {
      this.$message({
        message: '正在努力读取数据中',
        type: 'warning',
        duration: 0,
      })
      let that = this
      this.loading = true

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append(
        'resinfo',
        `年龄：${that.resinfo.basic_info.age ? that.resinfo.basic_info.age + '岁' : ''
        }，学历：${that.resinfo.basic_info.degree}，工作年限：${that.resinfo.basic_info.num_work_experience
        }，`
      )
      urlencoded.append('id', that.resinfo._id)
      urlencoded.append(
        'resinfo1',
        `职位名称：${that.resinfo.work_experience[0].job_title},在职时间：${that.resinfo.work_experience[0].start_time_year} ~ ${that.resinfo.work_experience[0].end_time_year},工作简介：${that.resinfo.work_experience[0].description}，`
      )
      urlencoded.append(
        'resinfo2',
        that.resinfo.work_experience.length > 1
          ? `职位名称：${that.resinfo.work_experience[1].job_title},在职时间：${that.resinfo.work_experience[1].start_time_year} ~ ${that.resinfo.work_experience[1].end_time_year},工作简介：${that.resinfo.work_experience[1].description}，`
          : 'null'
      )
      urlencoded.append('user', localStorage.getItem('token'))

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }

      fetch(' https://api.qilinpin.cn/gptapi/api/getResTag', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          that.loading = false
          console.log(result)
          let posres = JSON.parse(result).msg
          that.restagid = posres
          that.getResTagById(posres)

        })
        .catch((error) => {
          Message.closeAll()
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    getResTagById: function (id) {
      let that = this

      var myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/x-www-form-urlencoded')

      var urlencoded = new URLSearchParams()
      urlencoded.append('user', localStorage.getItem('token'))
      urlencoded.append('id', id)

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: urlencoded,
        redirect: 'follow',
      }
      that.loading = true
      fetch(' https://api.qilinpin.cn/gptapi/api/getResTagById', requestOptions)
        .then((response) => response.text())
        .then((result) => {
          console.log(result)
          let posresg = JSON.parse(result).msg
          that.getResTagInfo = posresg
          if (!posresg.res || posresg.res && posresg.res === '') {
            that.getResTagById(id)
          } else {
            Message.closeAll()
            that.createLtDoc()
          }
        })
        .catch((error) => {
          that.loading = false
          that.$message.error('无法连接网络,请检查WiFi或移动数据网络是否正常')
          console.log('error', error)
        })
    },
    createLtDoc: function () {
      this.$message({
        showClose: true,
        message: '数据下载完毕，正在生成报告中',
        duration: 0
      });
      let resinfo = this.resinfo
      let that = this
      let filename = '/lietoubaogaoDemo.docx'
      loadFile(filename, function (
        error,
        content
      ) {
        if (error) {
          throw error;
        }
        var zip = new PizZip(content);
        var doc = new Docxtemplater(zip, {
          paragraphLoop: true,
          linebreaks: true
        });
        let data = {
          AI_text: that.getResTagInfo.res === "" ? "_____" : that.getResTagInfo.res,
          realname: resinfo.basic_info.name === "" ? "_____" : resinfo.basic_info.name,
          age: resinfo.basic_info.age === "" ? "_____" : resinfo.basic_info.age,
          sex: resinfo.basic_info.gender === "" ? "_____" : resinfo.basic_info.gender,
          hunpei: "_____",
          address: "_____",
          phone: resinfo.contact_info.phone_number === "" ? "_____" : resinfo.contact_info.phone_number,
          email: resinfo.contact_info.email === "" ? "_____" : resinfo.contact_info.email,
          edu_history: '',
          work_history: '',
          project_info: ''
        }
        let education_experience = resinfo.education_experience
        let edutext = ''
        for (let i in education_experience) {
          edutext += `${education_experience[i].start_time_year}.${education_experience[i].start_time_month}-${education_experience[i].end_time_year}.${education_experience[i].end_time_month}     ${education_experience[i].school_name}     ${education_experience[i].major}     ${education_experience[i].degree}\n\n`
        }
        data.edu_history = edutext
        let work_experience = resinfo.work_experience
        let worktext = ''
        for (let i in work_experience) {
          worktext += `${work_experience[i].start_time_year}.${work_experience[i].start_time_month}-${work_experience[i].end_time_year === "" ? "_" : work_experience[i].end_time_year}.${work_experience[i].end_time_month === "" ? "_" : work_experience[i].end_time_month}     ${work_experience[i].company_name}\n职位:${work_experience[i].job_title}\n工作职责:\n${work_experience[i].description}\n\n\n`
        }
        data.work_history = worktext
        let project_experience = resinfo.project_experience
        let projecttext = ''
        for (let i in project_experience) {
          projecttext += `${project_experience[i].start_time_year}.${project_experience[i].start_time_month}-${project_experience[i].end_time_year === "" ? "_" : project_experience[i].end_time_year}.${project_experience[i].end_time_month === "" ? "_" : project_experience[i].end_time_month}     ${project_experience[i].project_name}\n项目职责:\n${project_experience[i].description}\n\n\n`
        }
        data.project_info = projecttext
        doc.setData(data);
        try {
          // render the document (replace all occurences of {first_name} by John, {last_name} by Doe, ...)
          doc.render();

        } catch (error) {
          console.log(JSON.stringify({ error: error }, that.replaceErrors));
          if (error.properties && error.properties.errors instanceof Array) {
            const errorMessages = error.properties.errors
              .map(function (error) {
                return error.properties.explanation;
              })
              .join('\n');
            console.log('errorMessages', errorMessages);
          }
          throw error;
        }
        var out = doc.getZip().generate({
          type: 'blob',
          mimeType:
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        });
        Message.closeAll()
        that.loading = false
        that.$message({
          message: '聘快快推荐报告下载完毕，请在浏览器-下载记录中查看',
          type: 'success',
          duration: 3,
        })
        saveAs(out, `聘快快推荐报告 ${resinfo.basic_info.name}.docx`);

      });
    }
  },
  mounted: function () {
    this.getResList()
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.myReceiveResumeIndex {
  width: 70vw;
  flex: 1;
  padding-top: 1px;
  position: relative;
  background-color: #e6e6e6;
  display: flex;
  flex-direction: column;
  align-content: flex-start;
  justify-content: flex-start;
  margin: 0 auto;

  .pppdgdg{
    position: fixed;
    bottom: 40px;
    right: 40px;
  }

  .boxxx{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-content: center;
    margin-top: 20px;
    .boxxx11{
      flex: 1;
      white-space: pre-line;
    }
    .el-textarea{
      flex: 1;
    }
  }

  .wpline{
    white-space: pre-line;
    line-height: 1.8;
  }

  .paginationBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffffff;
    width: max-content;
    padding: 5px 40px;
    z-index: 9999;
    border-radius: 10px;

    .el-pager {
      li {
        background: transparent;
        color: #5dc2d0;
      }

      .active {
        background: #fff;
        color: #5dc2d0;
      }
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;

      i {
        color: #ffffff;
      }
    }
  }


  .cont {
    // overflow-x: scroll;
    height: calc(100%);
    border-radius: 8px;
    box-sizing: border-box;
    // overflow: hidden;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;

    .selectCont {
      width: 311px;
      background-color: #ffffff;
      box-sizing: border-box;
      margin-top: 30px;
      padding: 35px 22px;
      border-radius: 10px;
      margin-left: 20px;


      .resitem {
        width: 262px;
        height: 77px;
        border-radius: 10px;
        border: 1px solid #5dc1cf;
        padding: 10px;
        box-sizing: border-box;
        margin-bottom: 10px;
        cursor: pointer;

        .p1 {
          font-size: 18px;
          color: #5dc1cf;
        }

        .p2 {
          font-size: 12px;
          color: #4d4d4d;
        }

        .p3 {
          font-size: 12px;
          color: #4d4d4d;
        }
      }

      .resitemactive {
        background-color: #5dc1cf;

        .p1 {
          font-size: 18px;
          color: #ffffff;
        }

        .p2 {
          font-size: 12px;
          color: #ffffff;
        }

        .p3 {
          font-size: 12px;
          color: #ffffff;
        }
      }
    }

    .tableCont {
      flex: 0.98;
      margin-top: 30px;
      box-sizing: border-box;
      background-color: #ffffff;
      margin-right: 20px;
      border-radius: 10px;
      padding: 30px;

      .bt {
        font-size: 20px;
        font-weight: bold;
        padding-left: 20px;
        height: 26px;
        line-height: 26px;
        border-left: 5px solid #5dc1cf;
        margin-bottom: 30px;
        margin-top: 30px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
      }

      .actionbox {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-end;
      }

    }
  }
}
</style>
